import createIcon from '../../createIcon';

/**
 * @component @name TrackChanges
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuMDcgNC45M0wxNy42NiA2LjM0QzE5LjEgNy43OSAyMCA5Ljc5IDIwIDEyQzIwIDE2LjQyIDE2LjQyIDIwIDEyIDIwQzcuNTggMjAgNCAxNi40MiA0IDEyQzQgNy45MiA3LjA1IDQuNTYgMTEgNC4wN1Y2LjA5QzguMTYgNi41NyA2IDkuMDMgNiAxMkM2IDE1LjMxIDguNjkgMTggMTIgMThDMTUuMzEgMTggMTggMTUuMzEgMTggMTJDMTggMTAuMzQgMTcuMzMgOC44NCAxNi4yNCA3Ljc2TDE0LjgzIDkuMTdDMTUuNTUgOS45IDE2IDEwLjkgMTYgMTJDMTYgMTQuMjEgMTQuMjEgMTYgMTIgMTZDOS43OSAxNiA4IDE0LjIxIDggMTJDOCAxMC4xNCA5LjI4IDguNTkgMTEgOC4xNFYxMC4yOEMxMC40IDEwLjYzIDEwIDExLjI2IDEwIDEyQzEwIDEzLjEgMTAuOSAxNCAxMiAxNEMxMy4xIDE0IDE0IDEzLjEgMTQgMTJDMTQgMTEuMjYgMTMuNiAxMC42MiAxMyAxMC4yOFYySDEyQzYuNDggMiAyIDYuNDggMiAxMkMyIDE3LjUyIDYuNDggMjIgMTIgMjJDMTcuNTIgMjIgMjIgMTcuNTIgMjIgMTJDMjIgOS4yNCAyMC44OCA2Ljc0IDE5LjA3IDQuOTNaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TrackChanges = createIcon('TrackChanges', [
  [
    'path',
    {
      d: 'M19.07 4.93L17.66 6.34C19.1 7.79 20 9.79 20 12C20 16.42 16.42 20 12 20C7.58 20 4 16.42 4 12C4 7.92 7.05 4.56 11 4.07V6.09C8.16 6.57 6 9.03 6 12C6 15.31 8.69 18 12 18C15.31 18 18 15.31 18 12C18 10.34 17.33 8.84 16.24 7.76L14.83 9.17C15.55 9.9 16 10.9 16 12C16 14.21 14.21 16 12 16C9.79 16 8 14.21 8 12C8 10.14 9.28 8.59 11 8.14V10.28C10.4 10.63 10 11.26 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 11.26 13.6 10.62 13 10.28V2H12C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 9.24 20.88 6.74 19.07 4.93Z',
      key: '10s2do',
    },
  ],
]);

export default TrackChanges;
